<template>
    <div class="vm-group-card flex-box relative pointer" @click="tap">
        <div class="mr16">
          <pic class="cover" :src="group.cover" :width="w" :height="h" />
        </div>
        <div class="flex-item-1 flex-box flex-justify-content-space-between flex-align-items-center lh1">
            <div>
                <div class="fs16 fwb flex-box flex-a-center">
                  {{ group.title }}
                  <i v-if="group.price != 0" class="afd afd-lightning_outline fwn fs12 purple-3 ml8"></i>
                  <tag v-if="group.is_owner && is_show_owner" class="purple tiny ml8">我的</tag>
                </div>
                <div class="flex-box flex-justify-content-space-between fs14 black-3 mt8">
                    <span>{{group.post_count > 0 ? `${$t('c.GroupCard.text1')} ${group.post_count}`: $t('c.GroupCard.text2')}}</span>
                </div>
            </div>
            <div>
                <span v-if="group.new_post_count >= 0" class="purple">
                    <i v-if="group.new_post_count == 0" class="afd afd-arrow-right mr8 black-5"></i>
                    <tag class="circle purple" v-else>
                        {{ group.new_post_count }}
                    </tag>
                </span>
            </div>
            <!-- <div class="flex-box mt4">
        <avatar-stack></avatar-stack>
      </div>-->
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    props: {
        group: {
            type: Object,
            default() {
                return null;
            },
        },
        is_show_owner:{
          default() {
              return true;
          },
        }
    },
    data() {
        return {};
    },
    computed: {
        ...mapState("app", ["browser_size", "session_user"]),
        w(){
          return this.browser_size == 'small' ? 48 : 64
        },
        h(){
          return this.browser_size == 'small' ? 48 : 64
        },
    },
    mounted() {},
    methods: {
        tap() {
            this.$mixin_router_push(`/group/${this.group.group_id}`);
        },
    },
};
</script>

<style lang="stylus" scoped>
.vm-group-card {
  box-sizing: border-box;
  border: 1px solid $black-1;
  border-radius: 4px;
  padding: 16px;

  &:hover {
    box-shadow: $layer-box-shadow;
  }

  .cover {
    width: 64px;
    border-radius: 6px;
    overflow: hidden;
  }
  @media (max-width: $width-mobile) {
    .cover {
      width: 48px;
    }
  }
}
</style>
